export default __webpack_public_path__ + "static/media/empathie.ae9afa0d.jpg";